import ToggleButton from "@visa/vds/toggle-button";
import ToggleButtonListStateless from "@visa/vds/toggle-button-list-stateless";
import ToggleButtonSet from "@visa/vds/toggle-button-set";
import React, { useState } from "react";

const ToggleFlagOrParam = (props) => {
  const [toggleFlagOrParam, setToggleFlagOrParam] = useState({
    items: [
      {
        checked: true,
        label: "SHOW: VMID Participation Flags",
        value: "2",
      },
      {
        checked: false,
        label: "SHOW: VMID Parameters",
        value: "1",
      },
    ],
  });

  const handleChange = (e) => {
    props.setShowParam(e.target.value === "1");
    props.setShowFlag(e.target.value === "2");
    setToggleFlagOrParam({
      items: [
        ...toggleFlagOrParam.items.map((item) => ({
          ...item,
          checked: item.value === e.target.value,
        })),
      ],
    });
  };

  return (
    <ToggleButtonSet>
      <ToggleButtonListStateless>
        {toggleFlagOrParam.items.map((item, k) => (
          <ToggleButton
            key={k}
            checked={item.checked}
            id={`toggle-button-${k}`}
            label={item.label}
            name="toggle-stateless"
            onChange={handleChange}
            value={item.value}
          />
        ))}
      </ToggleButtonListStateless>
    </ToggleButtonSet>
  );
};
export default ToggleFlagOrParam;
